// Google tracking loader — supports GA4 (G-XXXXXXXXXX) and Tag Manager (GTM-XXXXXXX).
// No-op until REACT_APP_GA_ID is set.
export const initGA = () => {
  const id = (process.env.REACT_APP_GA_ID || '').trim();
  if (!id) return;
  window.dataLayer = window.dataLayer || [];
  if (id.startsWith('GTM-')) {
    window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
    document.head.appendChild(s);
    return;
  }
  if (id.startsWith('G-')) {
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.gtag = function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', id);
  }
};
